import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Descriptions } from 'antd'

import Button from 'src/components/Button'
import { ButtonRow } from './styled'

// The two fields are label and value pairs, which is exactly what the form asks to copy. They
// come before the button: read afterwards, the form is already open.
const HelpContact = props => {
  const { fields, ticketUrl } = props

  return (
    <>
      <p>
        <FormattedMessage id={'help.contact.intro'} />
      </p>
      <Descriptions bordered size={'small'} column={1}>
        {fields.map(field => (
          <Descriptions.Item
            key={field}
            label={<FormattedMessage id={`help.contact.${field}.label`} />}>
            <FormattedMessage id={`help.contact.${field}.value`} />
          </Descriptions.Item>
        ))}
      </Descriptions>
      <ButtonRow>
        <a href={ticketUrl} target={'_blank'} rel={'noopener noreferrer'}>
          <Button>
            <FormattedMessage id={'help.contact.button'} />
          </Button>
        </a>
      </ButtonRow>
    </>
  )
}
HelpContact.propTypes = {
  fields: PropTypes.array.isRequired,
  ticketUrl: PropTypes.string.isRequired
}
export default HelpContact
